import React from 'react';
import { TableCell, TableSortLabel, type TableCellProps } from '@mui/material';

export interface SortableTableCellProps extends Omit<TableCellProps, 'sortDirection'> {
  field: string;
  sortField: string | null;
  sortDirection: 'asc' | 'desc';
  onSort: (field: string) => void;
  children: React.ReactNode;
}

/**
 * A TableCell that renders a clickable TableSortLabel header.
 * Drop-in replacement for `<TableCell sx={{ fontWeight: 600 }}>Label</TableCell>`.
 */
export const SortableTableCell: React.FC<SortableTableCellProps> = ({
  field,
  sortField,
  sortDirection,
  onSort,
  children,
  ...cellProps
}) => (
  <TableCell
    sortDirection={sortField === field ? sortDirection : false}
    {...cellProps}
    sx={{ fontWeight: 600, ...((cellProps.sx as Record<string, unknown>) ?? {}) }}
  >
    <TableSortLabel
      active={sortField === field}
      direction={sortField === field ? sortDirection : 'asc'}
      onClick={() => onSort(field)}
      sx={cellProps.align === 'right' ? { flexDirection: 'row' } : undefined}
    >
      {children}
    </TableSortLabel>
  </TableCell>
);
